// extracted by mini-css-extract-plugin
export var activeDot = "_2t-c";
export var buttonContainer = "_2t-9";
export var channelButton = "_2t-a";
export var clickable = "_2t-d";
export var content = "_2t-0";
export var contentFull = "_2t-2";
export var contentThird = "_2t-1";
export var contentWrapper = "_2t-7";
export var description = "_2t-5";
export var heightShort = "_2t-f";
export var image = "_2t-3";
export var imageContainer = "_2t-4";
export var selectButton = "_2t-e";
export var spinnerContainer = "_2t-b";
export var titleContent = "_2t-8";
export var titleWrapper = "_2t-6";